import { Component, OnInit, Inject, Input } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { CoreService } from 'src/app/core/core.service';

@Component({
  selector: 'prgov-side-list',
  templateUrl: './side-list.component.html',
  styleUrls: ['./side-list.component.scss'],
})
export class SideListComponent implements OnInit {
  @Input() data: any[];
  @Input() title: string;
  @Input() icon: string;
  @Input() addBtnDisabled = false;
  @Input() deleteBtnDisabled = false;
  // Types available = messages, bills, receipts and documents
  @Input() type: string;

  predefinedBillsMessages: any[];

  constructor(public dialog: MatDialog, private coreService: CoreService) {}

  ngOnInit() {
    // Get predefined messages obj
    // this.predefinedBillsMessages = this.coreService.getPredefinedBillsMessages();
  }
  addDialog(): void {
    const dialogRef = this.dialog.open(DialogSideListDialog, {
      width: '450px',
      data: {
        mode: 'add',
        type: this.type,
        title: this.title,
        predefinedBills: this.predefinedBillsMessages,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      // console.log('The dialog was closed');
    });
  }
  viewDetail(id: number) {
    // Get item clicked details
    // const ele = this.coreService.getItemDetails(id, this.data);
    // Open Dialog and send item details
    // const dialogRef = this.dialog.open(DialogSideListDialog, {
    //   width: '450px',
    //   data: {
    //     mode: 'view',
    //     type: this.type,
    //     title: this.title,
    //     item: ele,
    //     predefinedBills: this.predefinedBillsMessages,
    //   },
    // });
  }
  getPredefinedBillTitle(id: number): string {
    // const name: string = this.coreService.getItemSpecificDetail(
    //   id,
    //   'name',
    //   this.predefinedBillsMessages
    // );
    return ''//name;
  }
}

@Component({
  selector: 'dialog-side-list-dialog',
  templateUrl: 'dialog-side-list-dialog.html',
})
export class DialogSideListDialog {
  docTypes = [
    { value: 1, name: 'Subir archivo' },
    { value: 2, name: 'Generar a partir de información de perfil' },
  ];
  docTypesSelected = 1;
  constructor(
    public dialogRef: MatDialogRef<DialogSideListDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  showDocType(val: any) {
    console.log(val);
  }
}
